import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationUsers = 'OrganizationUsers',
}

export const useActivateUserMutation = () => {
  const { activateUser } = useServicesContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: number) => activateUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheKey.OrganizationUsers],
      });
    },
  });
};